// Find all tables with `responsive-table` class
const tableItem = document.querySelectorAll('.responsive-table');

if (tableItem) {
  tableItem.forEach((e) => {
    // Create wrapping element
    const wrapper = document.createElement('div');

    // Add classname to wrapping element
    wrapper.classList.add('responsive-wrapper');

    // Apply wrapper around the table
    e.parentNode.insertBefore(wrapper, e);
    wrapper.appendChild(e);
  });
}
